import { UserInput } from 'admin/inputs/UserInput';
import { Role } from 'generated/graphql';
import { CheckboxGroupInput, Edit, FormDataConsumer, RadioButtonGroupInput, SimpleForm } from 'react-admin';

import { SERVICE_AREA_TYPES, USER_RELATION_TYPES } from './userRelationUtils';

export const UserRelationEdit: React.FC = () => (
  <Edit mutationMode="pessimistic">
    <SimpleForm>
      <UserInput label="Kto" roles={[Role.RoleFinancialAdvisor]} source="subjectUser.id" />
      <RadioButtonGroupInput choices={USER_RELATION_TYPES} label="Má vzťah" source="relationType" />
      <UserInput label="Ku komu" roles={[Role.RoleClient]} source="objectUser.id" />
      <FormDataConsumer>
        {({ formData }) =>
          formData.relationType == 'ADDITIONAL_FINANCIAL_ADVISOR' && (
            <CheckboxGroupInput
              choices={SERVICE_AREA_TYPES}
              fullWidth={false}
              label="V oblastiach"
              source="serviceAreas"
            />
          )
        }
      </FormDataConsumer>
    </SimpleForm>
  </Edit>
);
